import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import './AnalyticsViewStyle.scss';
import SubHeader from '../../../Layout/SubHeader';
import ReportFilters from './ReportFilters';
import RiskPotential from './RiskPotential';

class AnalyticsView extends Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    /**
     * Render elements
     */
    render() {
        return (
            <div>
                <Row>
                    <Col md={12}>
                        <SubHeader />
                    </Col>
                </Row>
                <Row className="bg-white border-bottom">
                    <Col md={12}>
                        <ReportFilters />
                    </Col>
                </Row>

                <Row className="top-margin bg-white border-bottom">
                    <Col md={12}>
                        <RiskPotential />
                    </Col>
                </Row>
                <div ref={(el) => { this.messagesEnd = el; }}></div>
            </div>

        );
    }

}

export default (AnalyticsView);